export enum BiddingStatus {
  Bidder = "participating",
  Interested = "interested",
  NotInterested = "notinterested",
  Unknown = "unknown",
}
